<template>
    <div class="relative flex justify-center min-h-screen bg-gray-100 dark:bg-gray-900 items-center">
        <div class="top-0 right-0 px-6 py-4">
            <svg class="animate-spin-500ms animate-spin h-16 w-16 text-black mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 2.757 1.122 5.26 2.945 7.071l1.414-1.414z"></path>
            </svg>
        </div>

    </div>
</template>

<style scoped>
    .bg-gray-100 {
        background-color: #f7fafc;
        background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
    }

    @media (prefers-color-scheme: dark) {

        .dark\:bg-gray-900 {
            background-color: #1a202c;
            background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
        }
    }

    .animate-spin-500ms {
        animation-duration: 500ms;
    }
</style>

<script>
export default {
    created() {
        if (this.$page.props.auth.user) {
            this.$inertia.visit(this.route('customers.index'))
        } else {
            this.$inertia.visit(this.route('login'))
        }
    },
}
</script>
